import * as React from 'react';
import { ReactComponent as HistoricIconSVG } from '../../assets/icons/mevo/ic_historic.svg';
import IconPattern, { IconProps } from './_IconPattern';

const HistoricIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={HistoricIconSVG} variantPlaces={1} {...props} />;
};

export default HistoricIcon;
